<template>
  <div role="tablist" id="pageGrade">
    <b-row class="pt-3" id="titleCatGrade">
      <b-col sm="8 pt-1 title txtLeft" style="text-align: left !important">{{title || "Título não informado"}}</b-col>
      <b-col sm="4" class="right pr-0">
        <b-button variant="secondary" @click="pageLista()"><i class="fas fa-arrow-left"></i> Voltar</b-button>
      </b-col>
    </b-row>
    <b-card no-body class="mb-1 shadow mt-2">
      <b-card-body>
        <b-container fluid class="p-0">
          <div class="mt-4 mb-5 ml-2 mr-2">
            <img id="imgGrade" v-if="produtoSelecionado.url" :src="produtoSelecionado.url" alt="">
            <span class="semImagem" v-else><img src="@/assets/sem-imagem.png" alt="" /></span>
          </div>
          <b-card border-variant="light" class="shadow2 mb-3" id="dadosGradeDesk">
            <b-card-text>
              <b-row class="mb-2">
                <b-col cols="4"  class="txtLeft"><b>Nome: </b> {{gradeProdutos.descricaoGrade}}</b-col>
                <b-col cols="4" class="txtLeft" v-if="produtoSelecionado.codigo && !empresaKatec"><b>Item: </b>{{produtoSelecionado.codigo}}</b-col>
                <b-col cols="4" class="txtLeft" v-else-if="produtoSelecionado.codigo && empresaKatec"><b>Código: </b>{{produtoSelecionado.codigo}}</b-col>
                <b-col cols="4" class="txtLeft" v-else-if="!produtoSelecionado.codigo && empresaKatec"><b>Código: </b> - </b-col>
                <b-col cols="4" class="txtLeft" v-else><b>Item: </b> - </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col cols="4" class="txtLeft" v-if="produtoSelecionado.ean && !empresaKatec"><b>Cód. Barras: </b>{{produtoSelecionado.ean}}</b-col>
                <b-col cols="4" class="txtLeft" v-else-if="!produtoSelecionado.ean && !empresaKatec"><b>Cód. Barras: </b> - </b-col>
                <b-col cols="4" class="txtLeft" v-if="produtoSelecionado.estoque"><b>Estoque: </b>{{formatQtde(produtoSelecionado.estoque)}}</b-col>
                <b-col cols="4" class="txtLeft" v-else><b>Estoque: </b> - </b-col>
                <b-col cols="4" class="txtLeft" v-if="produtoSelecionado.unidMed"><b>Unid.Med: </b>{{produtoSelecionado.unidMed}}</b-col>
                <b-col cols="4" class="txtLeft" v-else><b>Unid.Med: </b> - </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col class="txtLeft"><b>Estoque atualizado:</b> {{dateTime}}</b-col>
              </b-row>
              <b-row class="mb-2" v-if="!empresaKatec">
                <b-col class="txtLeft" v-if="produtoSelecionado.descricao"><b>Descrição: </b>{{produtoSelecionado.descricao}}</b-col>
                <b-col class="txtLeft" v-else><b>Descrição: </b> - </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col class="txtLeft col-4" v-if="previsao.data && !empresaKatec"><b>Previsão: </b>{{previsao.data}}</b-col>
                <b-col class="txtLeft col-4" v-else-if="previsao.data && empresaKatec"><b>Próx. Chegada: </b>{{previsao.data}}</b-col>
                <b-col class="txtLeft col-4" v-else-if="!previsao.data && empresaKatec"><b>Próx. Chegada: </b> - </b-col>
                <b-col class="txtLeft col-4" v-else><b>Previsão: </b> - </b-col>
                <b-col class="txtLeft col-4" v-if="produtoSelecionado.foraDeLinha === 0 && previsao.quantidade && !empresaKatec"><b>Qtd. prevista: </b> {{formatQtde(previsao.quantidade)}}</b-col>
                <b-col class="txtLeft col-4" v-else-if="produtoSelecionado.foraDeLinha === 0 && previsao.quantidade && empresaKatec"><b>Qtd. disp.: </b> {{formatQtde(previsao.quantidade)}}</b-col>
                <b-col class="txtLeft col-4" v-else-if="produtoSelecionado.foraDeLinha === 0 && !previsao.quantidade && empresaKatec"><b>Qtd. disp.: </b> - </b-col>
                <b-col class="txtLeft col-4" v-else><b>Qtd. prevista: </b> -</b-col>
                <b-col cols="4" class="txtLeft text-danger" v-if="produtoSelecionado.foraDeLinha === 0 && previsao.data === 'Sem Previsão'"><b>Sem Reposição</b></b-col>
              </b-row>
              <b-row class="mb-2" style="background: #eee">
                <b-col class="txtCenter"><b>{{this.tabela.descricao}}</b></b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col class="txtLeft col-4"><b>Preço Tabela: </b>R$ {{formatPrice(produtoSelecionado.precoTabela)}}</b-col>
                <b-col class="txtLeft col-4"><b>IPI: </b>{{produtoSelecionado.percentualIpi}}%</b-col>
                <b-col class="txtLeft col-4"><b>Preço com IPI: </b>R$ {{formatPrice(produtoSelecionado.precoComIpi)}}</b-col>
              </b-row>
              <b-row>
                <b-col class="txtLeft col-4"><b>Preço M²: </b>R$ {{formatPrice(produtoSelecionado.valorM2)}}</b-col>
                <b-col class="txtLeft col-4"><b>Preço M² com IPI: </b>R$ {{formatPrice(produtoSelecionado.precoM2ComIpi)}}</b-col>
              </b-row>
            </b-card-text>
          </b-card>
          <b-card border-variant="light" class="shadow2 mb-3" id="dadosGradeMob">
            <b-card-text>
              <b-row class="mb-1">
                <b-col cols="6" class="txtLeft"><b>Nome: </b> {{gradeProdutos.descricaoGrade}}</b-col>
                <b-col cols="6" class="txtRight" v-if="produtoSelecionado.codigo"><b>Item: </b>{{produtoSelecionado.codigo}}</b-col>
                <b-col cols="6" class="txtRight" v-else><b>Item: </b> - </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col class="txtLeft" v-if="produtoSelecionado.descricao"><b>Descrição: </b>{{produtoSelecionado.descricao}}</b-col>
                <b-col class="txtLeft" v-else><b>Descrição: </b> - </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col cols="6" class="txtLeft" v-if="produtoSelecionado.estoque"><b>Estoque: </b>{{formatQtde(produtoSelecionado.estoque)}}</b-col>
                <b-col cols="6" class="txtLeft" v-else><b>Estoque: </b> - </b-col>
                <b-col cols="6" class="txtRight" v-if="produtoSelecionado.unidMed"><b>Unid.Med: </b>{{produtoSelecionado.unidMed}}</b-col>
                <b-col cols="6" class="txtRight" v-else><b>Unid.Med: </b> - </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col class="txtLeft"><b>Estoque atualizado:</b> {{dateTime}}</b-col>
              </b-row>
              <b-row class="mb-1" v-if="produtoSelecionado.ean && !empresaKatec">
                <b-col class="txtLeft" v-if="produtoSelecionado.ean"><b>Cód. Barras: </b>{{produtoSelecionado.ean}}</b-col>
                <b-col class="txtLeft" v-else><b>Cód. Barras: </b> - </b-col>
              </b-row>
              <b-row class="mb-1" v-if="previsao.data">
                <b-col class="txtLeft" v-if="previsao.data"><b>Previsão: </b>{{previsao.data}}</b-col>
                <b-col class="txtLeft" v-else><b>Previsão: </b> - </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col cols="6" class="txtLeft" v-if="produtoSelecionado.foraDeLinha && produtoSelecionado.foraDeLinha === 0"><b>Qtd. prevista: </b> {{previsao.quantidade}}</b-col>
                <b-col cols="6" class="txtLeft" v-else><b>Qtd. prevista: </b> - </b-col>
                <b-col cols="6" class="txtRight text-danger" v-if="produtoSelecionado.foraDeLinha === 0 && previsao.data === 'Sem Previsão'"><b>Sem Reposição</b></b-col>
              </b-row>
              <b-row class="mb-1" style="background: #eee" id="tabelaPreco">
                <b-col class="txtCenter"><b>{{this.tabela.descricao}}</b></b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col class="txtLeft"><b>Preço Tabela: </b>R$ {{formatPrice(produtoSelecionado.precoTabela)}}</b-col>
              </b-row>
              <b-row class="mb-1" v-if="produtoSelecionado.percentualIpi">
                <b-col cols="6" class="txtLeft"><b>IPI: </b>{{produtoSelecionado.percentualIpi}}%</b-col>
                <b-col cols="6" class="txtRight"><b>Preço com IPI: </b>R$ {{formatPrice(produtoSelecionado.precoComIpi)}}</b-col>
              </b-row>
              <b-row class="mb-1" v-if="produtoSelecionado.valorM2">
                <b-col cols="6" class="txtLeft"><b>Preço M²: </b>R$ {{formatPrice(produtoSelecionado.valorM2)}}</b-col>
                <b-col cols="6" class="txtRight"><b>Preço M² com IPI: </b>R$ {{formatPrice(produtoSelecionado.precoM2ComIpi)}}</b-col>
              </b-row>
            </b-card-text>
          </b-card>
          <b-row class="mb-3" v-if="tamanhos.length > 0">
            <b-col md="11" class="titleFluid"><p>MODELO</p></b-col>
          </b-row>
          <b-card border-variant="light" class="shadow2 mb-3" id="modelosGrade" v-if="tamanhos.length > 0">
            <b-card-text>
              <swiper :options="swiperOptionModelos" id="sliderTamanhos">
                <swiper-slide v-for="(tamanho, index) in tamanhos" :key="tamanho.codigoTamanho" @click.native="selecionarCores(index)">
                  <b-button variant="secondary" :class="tamanho.active">{{tamanho.descricaoTamanho}}</b-button>
                </swiper-slide>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
              </swiper>
            </b-card-text>
          </b-card>
          <b-row class="mb-3" v-if="cores.length > 0">
            <b-col md="11" class="titleFluid"><p>VARIANTE</p></b-col>
          </b-row>
          <!--vendaSobMedidaM2: {{produtoSelecionado.vendaSobMedidaM2}} - {{itemPedido}}-->
          <b-card border-variant="light" class="shadow2 mb-3" id="variantesGrade" v-if="cores.length > 0">
            <b-card-text>
              <swiper :options="swiperOptionVariantes" id="sliderCores">
                <swiper-slide  v-for="(cor, index) in cores" :key="cor.codigo" @click.native="selecionarProduto(cor.cor, index)" class="selecionar-variante">
                  <div class="img" v-if="cor.cor.url"><img :src="cor.cor.url" :class="cor.classe" alt=""/></div>
                  <div class="img semImgItem" v-else><img src="@/assets/sem-imagem.png" alt="" :class="cor.classe" /></div>
                  <label class="mt-4">{{cor.cor.descricaoCor}}</label>
                </swiper-slide>
              </swiper>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </b-card-text>
          </b-card>
        </b-container>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
  import { broadcastServer, operacao, modo } from '@/main'
  import 'swiper/dist/css/swiper.css'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import spinnerVue from '@/components/items/SpinnerVue'
  export default {
    name: 'TableClientesVue',
    props: ['title'],
    components: {
      swiper,
      swiperSlide,
      spinnerVue
    },
    data () {
      return {
        empresaKatec: false,
        dateTime: '',
        grade: {},
        tabela: {},
        blockUiVisibility: false,
        gradeProdutos: {},
        exibeModal: false,
        tamanhos: [],
        tamanhoSelecionado: {},
        coresTamanhos: [],
        cores: [],
        corSelecionada: {},
        indiceCorSelecionada: 0,
        produtoSelecionado: {},
        previsao: {
          data: '',
          quantidade: ''
        },
        swiperOptionModelos: {
          slidesPerView: 3,
          spaceBetween: 3,
          freeMode: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
        swiperOptionVariantes: {
          slidesPerView: 4,
          spaceBetween: 6,
          freeMode: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          breakpoints: {
            1000: {
              slidesPerView: 4,
              spaceBetween: 10
            },
            700: {
              slidesPerView: 3,
              spaceBetween: 10
            },
            500: {
              slidesPerView: 2,
              spaceBetween: 10
            },
            400: {
              slidesPerView: 1,
              spaceBetween: 10
            }
          }
        }
      }
    },
    created: function () {
      let empresa = localStorage.getItem('empresaLogada')
      if (JSON.parse(empresa).identificador === 2355480534) {
        this.empresaKatec = true
      }
      broadcastServer.$on('pageViewGrade', parametro => {
        window.scrollTo(0, 0)
        // console.log(parametro)
      })
      broadcastServer.$on('responseGrade', param => {
        window.scrollTo(0, 0)
        // console.log(param.gradeProdutos)
        this.dataHoraEstoque()
        this.tabela = param.tabela
        this.gradeProdutos = param.gradeProdutos
        let tamanhos = []
        let tamanhosGrade = param.gradeProdutos.tamanhos.sort((a, b) => (a.descricaoTamanho > b.descricaoTamanho) ? 1 : ((b.descricaoTamanho > a.descricaoTamanho) ? -1 : 0))
        for (var iTam = 0; iTam < tamanhosGrade.length; iTam++) {
          let tamanho = tamanhosGrade[iTam]
          if (iTam === 0) {
            tamanhos.push({codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, active: 'active'})
            this.tamanhoSelecionado = {codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, active: 'active'}
          } else {
            tamanhos.push({codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, active: ''})
          }
        }
        this.tamanhos = tamanhos
        if (this.tamanhos.length > 0) {
          this.selecionarCores(0)
        }
        // this.grade = parametro
      })
    },
    methods: {
      dataHoraEstoque: function () {
        let today = new Date()
        let date = ('0' + today.getDate()).slice(-2) + '/' + ('0' + (today.getMonth() + 1)).slice(-2) + '/' + today.getFullYear().toString().substr(-2)
        let hour = ('0' + today.getHours()).slice(-2)
        let minute = ('0' + today.getMinutes()).slice(-2)
        let time = hour + ':' + minute
        this.dateTime = date + ' - ' + time
      },
      pageLista: function () {
        broadcastServer.$emit('filtroCatalogo', '')
        let parametro = {operacao: operacao.ADICIONAR, modo: modo.LISTA}
        broadcastServer.$emit('pageViewGrade', parametro)
      },
      formatPrice (value) {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      formatQtde: function (qtde) {
        if (typeof qtde !== 'undefined') {
          return qtde.toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        }
      },
      selecionarCores (indiceTamanhoSelecionado) {
        this.produtoSelecionado = {lotes: []}
        for (var iTam = 0; iTam < this.tamanhos.length; iTam++) {
          this.tamanhos[iTam].active = ''
          if (indiceTamanhoSelecionado === iTam) {
            this.tamanhos[iTam].active = 'active'
          }
        }
        let tamanho = this.gradeProdutos.tamanhos[indiceTamanhoSelecionado]
        this.tamanhoSelecionado = tamanho
        let cores = this.gradeProdutos.produtos.filter(prod => prod.codigoTamanho === tamanho.codigoTamanho)
        this.cores = []
        for (var iCor = 0; iCor < cores.length; iCor++) {
          let cor = cores[iCor]
          if (iCor === 0) {
            this.cores.push({cor: cor, classe: 'imgSelecionada'})
            this.corSelecionada = {cor: cor, classe: 'imgSelecionada'}
          } else {
            this.cores.push({cor: cor, classe: 'imgNaoSelecionada'})
          }
        }
        this.coresTamanhos = cores
        if (this.cores.length > 0) {
          this.selecionarProduto(this.cores[0].cor, 0)
        }
        // console.log('cores: ' + JSON.stringify(cores))
      },
      selecionarProduto (corSelecionada, indiceCorSelecionada) {
        this.produtoSelecionado = {lotes: []}

        this.corSelecionada = corSelecionada
        this.indiceCorSelecionada = indiceCorSelecionada
        for (var iCor = 0; iCor < this.cores.length; iCor++) {
          this.cores[iCor].classe = 'imgNaoSelecionada'
          if (indiceCorSelecionada === iCor) {
            this.cores[iCor].classe = 'imgSelecionada'
          }
        }
        let produtos = this.gradeProdutos.produtos.filter(prod => prod.codigoTamanho === this.tamanhoSelecionado.codigoTamanho && prod.codigoCor === corSelecionada.codigoCor)
        if (produtos.length > 0) {
          this.produtoSelecionado = produtos[0]
          this.previsao.data = (this.produtoSelecionado.previsao.length === 0 ? 'Sem Previsão' : this.produtoSelecionado.previsao[0].dataPrevisao)
          this.previsao.quantidade = (this.produtoSelecionado.previsao.length === 0 ? '' : this.produtoSelecionado.previsao[0].quantidade)
        }
        // console.log('produto selecionado: ' + JSON.stringify(this.produtoSelecionado))
      },
      onSlideStart (index) {
        let descricao = this.destaques[index].descricao
        this.descricao = descricao
      },
      onSlideEnd (index) {
        let descricao = this.destaques[index].descricao
        this.descricao = descricao
      }
    }
  }
</script>
<style scoped>
  #modelosGrade .card-text,
  #variantesGrade .card-text {
    padding: 0 15px;
  }
  #modelosGrade .card-body,
  #variantesGrade .card-body {
    padding: 1.25rem 30px;
  }
  .btn-circle {
    width: 30px;
    height: 30px;
    padding: 6px 0px;
    border-radius: 25px;
    text-align: center;
    font-size: 12px;
    line-height: 1.42857;
    margin-top: 32px;
  }
  .btn-secondary:not(:disabled):not(.disabled).active,
  .btn-secondary:not(:disabled):not(.disabled):active,
  .show>.btn-secondary.dropdown-toggle, .btn-secondary:hover {
    background-color: #252b31 !important;
    border-color: #252b31 !important;
  }
  .img {
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
  }
  .img img {
    max-width: 100%;
    display: block;
  }
  .semImagem {
    max-width: 100%;
    max-height: 80px;
  }
  .semImgItem {
    max-width: 100%;
  }
  .semImgItem img {
    max-width: 100%;
    padding: 0 10px;
  }
  .imgSelecionada {
    max-height: 150px;
    box-shadow: 5px 15px 20px 0px rgba(23, 23, 23, 0.75);
  }
  .imgNaoSelecionada {
    max-height: 110px;
    box-shadow: 5px 10px 20px 0px rgba(183, 183, 183, 0.75);
  }
  .table {
    overflow-y: scroll;
    position: relative;
    height: 200px;
    font-size: 14px;
  }
  /* .selecionar-variante {
    height: 225px;
  } */
  /* #sliderTamanhos .swiper-slide {
    margin-right: 3px;
    width: auto !important;
  } */
  .swiper-pagination {
    position: relative !important;
    bottom: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/items/TableCatalGradeVue.vue